import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-buy-data',
  templateUrl: './buy-data.component.html',
  styleUrls: ['./buy-data.component.scss'],
})
export class BuyDataComponent implements OnInit {
  @Input() type: string;
  list: any[] = [];
  settedType: string = '';
  page: number = 0;

  constructor(
    private httpSv: HttpService
  ) { }

  async ngOnInit() {
    this.setChange({detail: {value: this.type}});
  }

  setChange(ev){
    this.page = 0;
    const typeLength = ev.detail.value.length;
    const type = ev.detail.value;
    this.settedType = type.slice(0, typeLength - 1);
    // this.doSearch();
  }

  async doSearch(){
    try{
      this.page++;
      let res: any = await this.httpSv.itemIndex(this.settedType, this.page);
      res = res.data?.data || res.data;
      this.list.push(...res);
    }catch(err){
      console.error(err);
    }
  }

  clearPage(){
    this.page = 0;
    this.list = [];
  }

}
